module.exports = __webpack_public_path__ + "images/file_icons_v2/vob-3975ce13c8227ef0244a8fe23ce3f096.svg";